import { FC } from 'react';
import { IconButton } from 'src/components/mui';
import { TagType } from 'src/service/tag';
import { X } from 'lucide-react';
import {
  Background,
  Container,
  ContentWrapper,
  ScrollWrapper,
  Title,
  TitleSection,
} from './styles';
import { TourModalProps } from './types';

export const TourPopup: FC<TourModalProps & { children?: any }> = ({
  open,
  setOpen,
  title,
  children,
  type,
}) => {
  const handleModalClick = (e) => {
    e.stopPropagation();
  };

  if (!open) return null;
  return (
    <Background
      onPointerDown={() => {
        setOpen(false);
      }}
    >
      <Container
        width={type === TagType.Iframe ? 'auto' : '800px'}
        onPointerDown={handleModalClick}
      >
        <TitleSection>
          <Title>{title}</Title>
          <IconButton
            onClick={() => {
              setOpen(false);
            }}
            sx={{
              color: 'white',
              borderRadius: '8px',
              '&:hover': {
                background: '#ffffff1a',
              },
              '& .MuiTouchRipple-root .MuiTouchRipple-child': {
                borderRadius: '8px',
              },
            }}
          >
            <X size={20} />
          </IconButton>
        </TitleSection>
        <ContentWrapper>
          <ScrollWrapper>{children}</ScrollWrapper>
        </ContentWrapper>
      </Container>
    </Background>
  );
};
